import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-edit-program-type',
  templateUrl: './edit-program-type.component.html'
})
export class EditProgramTypeComponent implements OnInit {

  addProgramForm: FormGroup | any;
  file: any;
  imageType: any;
  imageUrl: any;
  countryArr: any = [];
  IsFree: any;
  viewId: any;
  programList: any;

  constructor(public service: MainService, private router: Router,
    private activatedroute: ActivatedRoute) {
    this.activatedroute.params.subscribe((res) => {
      this.viewId = res.id;
    })
  }

  ngOnInit() {
    this.addProgramFormValidation();
    this.getProgramType()
  }

  // Add Subadmin Form Validation

  addProgramFormValidation() {
    this.addProgramForm = new FormGroup({
      'title': new FormControl('', Validators.compose([Validators.required])),
    });

  }

  // get program type list api integration 

  getProgramType() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.programType_view + `?_id=${this.viewId}`, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.programList = res.result;
        this.addProgramForm.patchValue({
          title: this.programList.programType,

        })
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }



  // Add Program Api Integration 

  editProgram() {
    const data = {
      _id: this.viewId,
      programType: this.addProgramForm.value.title,
    }
    this.service.showSpinner()
    this.service.putApi(ApiUrls.programType_edit, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.service.successToast(res.responseMessage)
        this.router.navigate(['/program-type-mgt'])
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }


}
